import { Time24Hour } from 'types/time'

// this enumeration being in order of the days of the week is relied upon in the code
// the index can be used as the day of week when working with moment
export enum ScheduleDay {
  Sunday = 'Su',
  Monday = 'M',
  Tuesday = 'T',
  Wednesday = 'W',
  Thursday = 'Th',
  Friday = 'F',
  Saturday = 'S'
}
export enum ScheduleDayLookup {
  Su = 'Sunday',
  M = 'Monday',
  T = 'Tuesday',
  W = 'Wednesday',
  Th = 'Thursday',
  F = 'Friday',
  S = 'Saturday'
}

export type ScheduleType = 'OnlyOnce' | 'Random'

export type ScheduleTriggerType = 'Always' | 'Passed' | 'RunOnce'

export interface ScheduleWindow {
  start: Time24Hour // in UTC, local to customer
  end: Time24Hour // in UTC, local to customer
  numOfRuns: number
}

export interface ScheduleTrigger {
  dayOfWeek: ScheduleDay
  scheduleWindows: ScheduleWindow[]
}

export interface ScheduleSettings {
  enabled: boolean
  scheduleType?: ScheduleType
  triggerType?: ScheduleTriggerType
  triggers?: ScheduleTrigger[]
}
